import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Product = () => {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState(""); // Dropdown filter state
  const [gender, setGender] = useState(""); // Dropdown filter state

  const [itemsPerPage] = useState(5);
  const URL = process.env.REACT_APP_URL;
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    axios
      .get(`${URL}products`)
      .then((response) => {
        setProducts(response.data);
      })
      .catch((error) => {
        enqueueSnackbar(`Error fetching products: ${error.message}`, {
          variant: "error",
        });
      });
  }, [URL, enqueueSnackbar]);

  const deleteProduct = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this product?"
    );
    if (!confirmed) return;

    try {
      const response = await axios.delete(`${URL}products/${id}`);
      if (response.status === 200) {
        setProducts(products.filter((product) => product.id !== id));
        enqueueSnackbar("Product deleted successfully!", {
          variant: "success",
        });
      } else {
        enqueueSnackbar("Failed to delete the product", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar(`Error: ${error.message}`, { variant: "error" });
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };
  const handleFilterChange = (e) => {
    setFilter(e.target.value);
    setCurrentPage(1);
  };

  const handlegender = (e) => {
    if (e) {
      console.log(e);
      setGender(e.target.value);
      setCurrentPage(1);
    }
  };

  const filteredProducts = products
    .filter(
      (product) =>
        product.productId.toLowerCase().includes(search.toLowerCase()) ||
        product.name.toLowerCase().includes(search.toLowerCase()) ||
        product.category.toLowerCase().includes(search.toLowerCase()) ||
        product.gender.toLowerCase().includes(search.toLowerCase())
    )
    .filter((product) => (gender ? product.gender === gender : true))
    .filter((product) => (filter ? product.category === filter : true))
    .sort((a, b) => b.id - a.id);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredProducts.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="p-4 md:p-8">
      <div className="flex justify-between items-center mb-6">
        <div className="flex space-x-4">
          <Link to="/add-product">
            <button className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-700">
              Add Product
            </button>
          </Link>
        </div>
        <h1 className="text-3xl font-bold text-gray-800">Products</h1>
      </div>

      <div className="flex justify-between items-center mb-6">
        <div className="w-full md:w-1/5">
          <input
            type="text"
            placeholder="Search products..."
            value={search}
            onChange={handleSearch}
            className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <select
          value={filter}
          onChange={handleFilterChange}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">All Products</option>
          <option value="Bracelet">Bracelet</option>
          <option value="Ring">Ring</option>
          <option value="Necklace">Necklace</option>
          <option value="Earrings">Earrings</option>
          <option value="Pendantset">Pendantset</option>
          <option value="Mangalsutra">Mangalsutra</option>
          <option value="Bengal">Bangel</option>
          <option value="Coupleband">Couple band's</option>
        </select>
        <select
          value={gender}
          onChange={handlegender}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Both Gender</option>
          <option value="Man">Men</option>
          <option value="Woman">Women</option>
        </select>
        <div className="flex items-center space-x-4">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-4 py-2 border border-gray-300 rounded-md text-white ${
              currentPage === 1
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
          >
            Previous
          </button>
          <span className="px-3 py-2 text-sm">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 border border-gray-300 rounded-md text-white ${
              currentPage === totalPages
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
          >
            Next
          </button>
        </div>
      </div>

      <div className="overflow-x-auto bg-white shadow-md rounded-lg">
        <table className="table-auto w-full border-collapse text-left">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2 text-sm font-semibold text-gray-600">
                #
              </th>
              <th className="px-4 py-2 text-sm font-semibold text-gray-600">
                Product Id
              </th>
              <th className="px-4 py-2 text-sm font-semibold text-gray-600">
                Name
              </th>
              <th className="px-4 py-2 text-sm font-semibold text-gray-600 hidden sm:table-cell">
                Gender
              </th>
              <th className="px-4 py-2 text-sm font-semibold text-gray-600 hidden sm:table-cell">
                Category
              </th>
              <th className="px-4 py-2 text-sm font-semibold text-gray-600">
                Image
              </th>
              <th className="px-4 py-2 text-sm font-semibold text-gray-600">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((product, index) => (
                <tr key={product.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2">{indexOfFirstItem + index + 1}</td>
                  <td className="px-4 py-2">{product.productId}</td>
                  <td className="px-4 py-2">{product.name}</td>
                  <td className="px-4 py-2 hidden sm:table-cell">
                    <td className="px-4 py-2 hidden sm:table-cell">
                      {product.gender === "Man" ? "Men" : "Women"}
                    </td>
                  </td>
                  <td className="px-4 py-2 hidden sm:table-cell">
                    {product.category == "Bengal" ? "Bangel" : product.category}
                  </td>
                  <td className="px-4 py-2">
                    <img
                      src={`${URL}upload/${product.image1}`}
                      alt={product.name}
                      className="w-16 h-16 object-cover rounded"
                    />
                  </td>
                  <td className="px-4 py-2">
                    <div className="flex space-x-2">
                      <Link to={`/viewProduct/${product.id}`}>
                        <button className="px-3 py-1 bg-blue-500 text-white rounded-lg hover:bg-blue-600 text-sm">
                          View
                        </button>
                      </Link>
                      <Link to={`/editProduct/${product.id}`}>
                        <button className="px-3 py-1 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 text-sm">
                          Edit
                        </button>
                      </Link>
                      <button
                        onClick={() => deleteProduct(product.id)}
                        className="px-3 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600 text-sm"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="text-center py-4 text-sm text-gray-500"
                >
                  No products found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Product;
